// The production config is almost identical. I'll keep the userPoolClientId versioned as it does no real harm
export const config = {
    Auth: {
        Cognito: {
            userPoolClientId: '5kcs990u4l55340ivvt869gckf',
            userPoolId: 'eu-central-1_zZfgW9C5X',
            loginWith: { // Optional
                oauth: {
                    domain: 'auth-kompzhub.auth.eu-central-1.amazoncognito.com',
                    scopes: ['openid','aws.cognito.signin.user.admin'],
                    redirectSignIn: ['http://localhost:8080'],
                    redirectSignOut: ['http://localhost:8080'],
                    responseType: 'code',
                },
                username: 'true',
                email: 'true', // Optional
                phone: 'false', // Optional
            }
        }
    }  
  }